import React from 'react';

import { styled, TextField } from '@gogame/components';
import { withFormField } from '@gogame/form';

const DEFAULT_COLORS = [
  '#CC0000',
  '#336699',
  '#8E24AA',
  '#7E57C2',
  '#3F51B5',
  '#4E6CEF',
  '#29B6F6',
  '#81D4FA',
  '#4DB6AC',
  '#B2DFDB',
  '#2BAF2B',
  '#DCE775',
  '#AED581',
  '#FFB74D',
  '#FFC107',
  '#FFE082',
  '#FF7043',
  '#FF5722',
  '#B2FF59',
  '#14E715',
  '#00B0FF',
  '#1DE9B6',
  '#7C4DFF',
  '#FF2D6F',
  '#E1BEE7',
  '#9575CD',
  '#EEFF41',
  '#B388FF',
];

const ColorInput = styled('input')`
  height: 25px;
  width: 110px;
  border: none;
  margin-right: 8px;
`;

const ColorPicker = ({ value, error, onChange, name }) => {
  const handleChange = (e, value) => {
    onChange(e, `${value ? value : e.target.value}`.toUpperCase());
  };

  return (
    <TextField
      label={'Color'}
      name={name}
      placeholder={'#000000'}
      value={value || ''}
      onChange={handleChange}
      required={true}
      error={error}
      affix={
        <React.Fragment>
          <ColorInput
            type={'color'}
            value={value || ''}
            onChange={handleChange}
            list={'presetColors'}
            data-cy={'colorPicker'}
          />
          <datalist id={'presetColors'}>
            {DEFAULT_COLORS.map((color, i) => (
              <option key={i} value={color} data-cy={`${color}-color`} />
            ))}
          </datalist>
        </React.Fragment>
      }
    />
  );
};

export default withFormField()(ColorPicker);
